export default __webpack_public_path__ + "static/20-1530d151a27bd3414c201b2b073c031d.png";